module.exports = __webpack_public_path__ + "assets/img/_TZ-.4570c567.png";